import React from 'react';
import Image from 'next/image';
import RatingStars from '@components/product/ProductRatingStars';

import styles from './ProductCard.module.scss';

export interface ProductCardProps {
  productImage: string;
  displayName: string;
  rating: string;
  reviews: string;
  productUrl: string;
  displayPrice: string;
  salePrice: string;
  trackClick: () => void;
}

const ProductCard = ({
  productImage,
  displayName,
  rating,
  reviews,
  productUrl,
  displayPrice,
  salePrice,
  trackClick,
}: ProductCardProps) => {
  const strippedPrice = parseInt(displayPrice?.replace?.(/\D/g, '') || '0');

  const displaySale = !!salePrice;

  const Price = () => {
    if (strippedPrice === 0) return null;

    if (displaySale) {
      return (
        <p className={styles.price}>
          <span className={styles.salePrice}>{salePrice}</span>{' '}
          <span className={styles.originalPrice}>{displayPrice}</span>
        </p>
      );
    }

    return <p className={styles.price}>{displayPrice}</p>;
  };
  return (
    <article>
      <a
        className={styles.productCard}
        href={productUrl}
        onClick={() => trackClick?.()}
      >
        <div className={styles.image}>
          <Image
            src={productImage}
            alt=""
            width={200}
            height={200}
            quality={75}
            sizes="220px"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
        <div className={styles.ratings}>
          <RatingStars rating={parseFloat(rating)} />
          <span className={styles.reviewTotal}>({reviews})</span>
        </div>
        <p className={styles.name}>{displayName}</p>
        <Price />
      </a>
    </article>
  );
};

export default ProductCard;
